import { actions, Icon, IconProps, KeyMap } from '@infotech-soe/erp-ui-kit';
import React, { HTMLAttributes, memo, MouseEvent } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { IPanelLink } from '../../../../models/dataset/DatasetRelated';
import { useTextOverflowed } from '../../../hooks/useTextOverflowed';
import WithTooltip from '../../menu/WithTooltip';

import { useLinkStyles } from './styles';

interface Props
  extends
    Pick<IPanelLink, 'icon' | 'label'>,
    Pick<
      HTMLAttributes<HTMLDivElement>,
      'onContextMenu' | 'onDragLeave' | 'onDragOver' | 'onDragStart' | 'onDrop'
    > {
  onClick: (e: MouseEvent<HTMLDivElement> | KeyboardEvent) => void;
  onRemoveItem: IconProps['onClick'];
}

const PanelLink = ({
  label,
  icon,
  onClick,
  onRemoveItem,
  ...restDndProps
}: Props) => {
  const classes = useLinkStyles();
  const { isOverflowed, textRef } = useTextOverflowed();

  const hotkeyRef = useHotkeys<HTMLDivElement>(
    [KeyMap[actions.CHANGE]],
    onClick,
    { preventDefault: true },
    [onClick]
  );

  return (
    <WithTooltip label={label} placement="bottom" condition={isOverflowed}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
        className={classes.link}
        draggable
        ref={hotkeyRef}
        onClick={onClick}
        {...restDndProps}
      >
        {icon && <Icon name={icon} />}
        <div ref={textRef}>{label}</div>
        <Icon
          className={classes.closeIcon}
          name="cross"
          onClick={onRemoveItem}
        />
      </div>
    </WithTooltip>
  );
};
export default memo(PanelLink);
